import React from 'react';
import { Card, Badge } from './ui';
import { CheckCircle, Book, BookOpen, BookMarked, Library, Notebook, BookType, Gift, PawPrint } from 'lucide-react';
export function Product() {
  const tomos = [{
    icon: <Book className="w-8 h-8 text-blue-400" data-id="element-94" data-mp="28cvgw0iwb96v" />,
    color: 'bg-blue-500/10 border-blue-500/20',
    title: 'TOMO 1 — Los Primeros 7 Días',
    subtitle: 'Empezá con el pie derecho desde el primer día',
    desc: 'Todo lo que necesitás hacer al llegar a casa para evitar errores que después cuestan meses corregir.'
  }, {
    icon: <BookOpen className="w-8 h-8 text-emerald-400" data-id="element-95" data-mp="2r1sa012k3vni" />,
    color: 'bg-emerald-500/10 border-emerald-500/20',
    title: 'TOMO 2 — Pis en su Lugar',
    subtitle: 'Método Sin Estrés para el Control de Esfínteres',
    desc: 'Aprendé una rutina clara para que tu cachorro haga pis donde corresponde sin castigos ni confusión.'
  }, {
    icon: <BookMarked className="w-8 h-8 text-amber-400" data-id="element-96" data-mp="2w2g10mqscchq" />,
    color: 'bg-amber-500/10 border-amber-500/20',
    title: 'TOMO 3 — Basta de Mordidas y Destrozos',
    subtitle: 'Protegé tu casa y terminá con las mordidas',
    desc: 'Descubrí cómo terminar con las mordidas y proteger muebles, zapatillas y objetos de la casa.'
  }, {
    icon: <Library className="w-8 h-8 text-rose-400" data-id="element-97" data-mp="29jou4n585emp" />,
    color: 'bg-rose-500/10 border-rose-500/20',
    title: 'TOMO 4 — Noches Tranquilas, Dueños Descansados',
    subtitle: 'Volvé a descansar con toda tu familia',
    desc: 'Creá hábitos que ayuden a tu cachorro a descansar mejor y devolvé la tranquilidad a toda la familia.'
  }, {
    icon: <Notebook className="w-8 h-8 text-purple-400" data-id="element-98" data-mp="2o9mm7e69yoh6" />,
    color: 'bg-purple-500/10 border-purple-500/20',
    title: 'TOMO 5 — Socialización sin Miedo',
    subtitle: 'Más seguridad frente a personas, perros y ambientes nuevos',
    desc: 'Ayudalo a relacionarse con personas, perros y nuevos ambientes con seguridad y confianza.'
  }, {
    icon: <BookType className="w-8 h-8 text-orange-400" data-id="element-99" data-mp="125l4hl5fkz32" />,
    color: 'bg-orange-500/10 border-orange-500/20',
    title: 'TOMO 6 — Obediencia Paso a Paso',
    subtitle: 'Órdenes claras y buenos hábitos desde temprano',
    desc: 'Enseñale las órdenes básicas y construí buenos hábitos desde los primeros meses.'
  }];
  return <section className="py-12 px-4 bg-slate-900/30 pt-[4px] pb-[4px]" data-id="element-100" data-mp="1744qflk0yavf">
      <div className="max-w-5xl mx-auto" data-id="element-101" data-mp="1ltap98ey9z2s">
        <div className="text-center mb-10" data-id="element-102" data-mp="1lwgagckgkgt8">
          <Badge variant="success" className="mb-4" data-id="element-103" data-mp="1gw220tey34uo">
            PUNTO DIGITAL™ — KIT COMPLETO PARA TU CACHORRO
          </Badge>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-104" data-mp="1uuibut83tbh1">
            Este no es un ebook genérico
          </h2>
          <p className="text-xl text-slate-400" data-id="element-105" data-mp="1pu4dy407vhwq">
            Es un sistema compuesto por seis tomos, creado para resolver los
            problemas específicos que viven los dueños durante los primeros
            meses.
          </p>
          <div className="flex flex-wrap justify-center gap-2 mt-6 text-sm font-medium text-brand-400" data-id="element-106" data-mp="274zrxaqk2hfk">
            <span data-id="element-107" data-mp="2c4m9txhbwlup">Pis dentro de casa</span>{' '}
            <span className="text-slate-600" data-id="element-108" data-mp="2c6gvxf4c6k0d">→</span>
            <span data-id="element-109" data-mp="1ybwkbj2lcysu">Mordidas</span> <span className="text-slate-600" data-id="element-110" data-mp="1ycg12wgi9h5a">→</span>
            <span data-id="element-111" data-mp="22eaz9s353eeu">Noches sin dormir</span>{' '}
            <span className="text-slate-600" data-id="element-112" data-mp="22czzs4gq8stj">→</span>
            <span data-id="element-113" data-mp="1oe8o0opc7j8k">Miedos</span> <span className="text-slate-600" data-id="element-114" data-mp="1odqit2kp5uoi">→</span>
            <span data-id="element-115" data-mp="1oh4ks9pg81vf">Desobediencia</span> <span className="text-slate-600" data-id="element-116" data-mp="1tee7hhlgdzfk">→</span>
            <span data-id="element-117" data-mp="1tf66l2e9efal">Soluciones</span>
          </div>
        </div>

        <div className="mb-10" data-id="element-118" data-mp="1ff545iicizt0">
          <h3 className="text-xl font-bold text-white mb-5 flex items-center gap-3" data-id="element-119" data-mp="1ffwmvsquh31v">
            <PawPrint className="w-8 h-8 text-brand-400" data-id="element-120" data-mp="1jg75c4vtplxm" /> Cada problema tiene
            una solución específica
          </h3>
          <p className="text-slate-400 text-sm leading-relaxed mb-5" data-id="element-121" data-mp="39qa349ihmo20">
            No todos los dueños llegan con la misma preocupación. Algunos buscan
            terminar con el pis dentro de casa; otros necesitan frenar las
            mordidas o dormir tranquilos nuevamente. Por eso este Kit está
            dividido en seis métodos diferentes, cada uno pensado para resolver
            un desafío específico.
          </p>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-122" data-mp="2a6b1p20qq1ts">
            {tomos.map((tomo, i) => <Card key={i} className={`border ${tomo.color}`} data-id="element-123" data-mp="263y0mqwxus3c" data-mpi={i}>
                <div className="flex items-start gap-4" data-id="element-124" data-mp="266aqrrcuo8rh">
                  <div className="p-3 bg-slate-900 rounded-xl shrink-0" data-id="element-125" data-mp="21cg88r8zdztz">
                    {tomo.icon}
                  </div>
                  <div data-id="element-126" data-mp="1weo6l5ijazcl">
                    <h4 className="font-bold text-white text-lg mb-1" data-id="element-127" data-mp="1wc225eqxwzyl">
                      {tomo.title}
                    </h4>
                    <p className="text-brand-400 text-sm font-medium mb-3" data-id="element-128" data-mp="1mggr6r3w8pcp">
                      {tomo.subtitle}
                    </p>
                    <p className="text-slate-400 text-sm leading-relaxed" data-id="element-129" data-mp="1iff1p1zs3rnx">
                      {tomo.desc}
                    </p>
                  </div>
                </div>
              </Card>)}
          </div>
        </div>

        <Card className="bg-slate-900" data-id="element-130" data-mp="6xitpfxja0c0">
          <h4 className="font-bold text-xl text-white mb-6" data-id="element-131" data-mp="6ykisobdwncq">
            En cada método encontrás:
          </h4>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-132" data-mp="bvu720n1esyz">
            {['Pasos claros para actuar cuando aparece el problema', 'Rutinas para evitar que el desafío se repita', 'Señales para entender qué necesita tu cachorro', 'Acciones simples para generar hábitos que se sostienen', 'Decisiones más seguras para el día a día', 'Alternativas para adaptar el método a tu realidad', 'Recursos listos para aplicar desde hoy', 'Soluciones pensadas para familias argentinas'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-133" data-mp="2wki47qc7yu0z" data-mpi={i}>
                <CheckCircle className="w-5 h-5 text-emerald-500 shrink-0 mt-0.5" data-id="element-134" data-mp="2oku1q43f9mvs" />
                <span className="text-slate-300" data-id="element-135" data-mp="2kl3bq2lpzasb">{item}</span>
              </div>)}
          </div>
        </Card>
      </div>
    </section>;
}
export function Bonuses() {
  const bonuses = [{
    title: 'Calculadora de Porciones según Peso/Edad',
    desc: 'Dejá de calcular a ojo y ganá tranquilidad al saber qué cantidad ofrecer en cada etapa.',
    value: '$8.000'
  }, {
    title: 'Lista de lo que nunca debe morder o comer',
    desc: 'Prevení sustos y evitá que la curiosidad de tu cachorro se convierta en una emergencia.',
    value: '$8.000'
  }, {
    title: '100 juegos de estimulación para tu cachorro',
    desc: 'Canalizá su energía antes de que termine en muebles rotos, zapatillas mordidas o frustración.',
    value: '$9.000'
  }, {
    title: 'Calendario de Entrenamiento 30 Días',
    desc: 'Dejá de improvisar: seguí un paso por día para crear hábitos sin sentirte abrumado.',
    value: '$8.000'
  }, {
    title: 'Guía de Emergencias: Cuándo ir al veterinario',
    desc: 'Identificá cuándo observar, cuándo actuar y cuándo pedir ayuda para decidir con más seguridad.',
    value: '$9.000'
  }];
  return <section className="py-12 px-4" data-id="element-136" data-mp="13sy3dusaevcw">
      <div className="max-w-5xl mx-auto" data-id="element-137" data-mp="13u0wm9d319vz">
        <div className="text-center mb-8" data-id="element-138" data-mp="1rgzbj2lk09rs">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 flex items-center justify-center gap-3" data-id="element-139" data-mp="1rian3ol8qltg">
            <Gift className="w-9 h-9 text-brand-400" data-id="element-140" data-mp="1vl72z7jec3tp" />5 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-xl text-brand-400 font-bold uppercase tracking-widest" data-id="element-141" data-mp="1hrfrvuq0obvv">
            Siempre incluidos
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-4 mb-8" data-id="element-142" data-mp="2aftoq75dd25u">
          {bonuses.map((bono, i) => <Card key={i} className={`relative overflow-hidden group hover:border-brand-500/50 transition-colors lg:col-span-2 ${i === 3 ? 'lg:col-start-2' : ''}`} data-id="element-143" data-mp="2f7bmyng0con4" data-mpi={i}>
              <div className="absolute top-0 right-0 bg-brand-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-144" data-mp="ad2ivnzoonfi">
                BONO {i + 1}
              </div>
              <h4 className="font-bold text-white text-lg mb-3 pr-12 mt-2" data-id="element-145" data-mp="g7o9g6j776i">
                {bono.title}
              </h4>
              <p className="text-slate-400 text-sm mb-6" data-id="element-146" data-mp="y2n4ken81ysh">{bono.desc}</p>
              <div className="mt-auto pt-4 border-t border-slate-800 flex justify-between items-center" data-id="element-147" data-mp="t4v1qpl1gs9i">
                <span className="line-through text-slate-500 text-sm" data-id="element-148" data-mp="o4z91mhskn99">
                  Valor {bono.value}
                </span>
                <span className="text-emerald-400 font-bold" data-id="element-149" data-mp="k359xin8vrb7">GRATIS</span>
              </div>
            </Card>)}
        </div>

        <div className="bg-gradient-to-r from-brand-900/50 to-emerald-900/50 border border-brand-500/30 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-150" data-mp="38tekqvwscaog">
          <p className="text-slate-300 mb-2" data-id="element-151" data-mp="1kd4xbz91emm8">Valor total bonos</p>
          <p className="text-4xl font-black text-white mb-2 line-through decoration-red-500/50" data-id="element-152" data-mp="1odfgkdlub9j1">
            $51.000
          </p>
          <p className="text-2xl font-bold text-emerald-400" data-id="element-153" data-mp="1tbqpmm4b9g07">
            → GRATIS con tu kit completo
          </p>
        </div>
      </div>
    </section>;
}